module.exports = __webpack_public_path__ + "img/lipei.1771e22f.png";